<template>
  <a 
    @click="handleDelete" 
    :class="['remove', disabled ? 'text-secondary disabled' : 'text-danger']" 
    v-tooltip="$t('form.button.remove')"
  >
    <i class="fas fa-trash"></i>
  </a>
</template>

<script>
/**
 * RelationDeleteButton - A reusable component for deleting child relationships
 * Handles both hierarchy and association deletions with proper data formatting
 */
export default {
  props: {
    relation: {
      type: Object,
      required: true
    },
    child: {
      type: Object,
      required: true
    },
    relationType: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onRemove: {
      type: Function,
      required: true
    }
  },

  methods: {
    handleDelete() {
      if (this.disabled) return;

      let data;

      // Handle association deletion
      if (this.child && this.child?.association_id) {
        data = {
          id: this.relation.id,
          name: this.relation.tag_name,
          childName: this.child?.name,
          delete_associations: [this.child?.association_id]
        }
      } else {
        // Handle hierarchy deletion
        data = { 
          ...this.relation, 
          tag_id: this.child?.id 
        };
        data.childName = this.child.name;
      }

      this.onRemove(this.relationType, data);
    }
  }
}
</script>

<style lang="scss" scoped>
.remove {
  cursor: pointer;
  margin: 0 5px;

  &.disabled {
    cursor: not-allowed;
  }
}
</style>